import { cn } from '@module/lib/utils';
import React from 'react';
import CloseButton from '../atoms/button/CloseButton';

const ModalContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'scrollbar-custom max-h-screen max-w-[calc(100vw-40px)] overflow-auto rounded-[16px] bg-card text-card-foreground shadow-sm',
        className,
      )}
      {...props}
    />
  ),
);
ModalContainer.displayName = 'ModalContainer';

const ModalHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-col space-y-1.5 px-6 pt-5 pb-0', className)} {...props} />
  ),
);

ModalHeader.displayName = 'ModalHeader';

const ModalTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h3
      ref={ref}
      className={cn('font-[700] text-colorFg01 text-xl leading-none tracking-tight', className)}
      {...props}
    />
  ),
);

ModalTitle.displayName = 'ModalTitle';

const ModalDescription = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => <p ref={ref} className={cn('text-[#777] text-sm', className)} {...props} />,
);

ModalDescription.displayName = 'ModalDescription';

const ModalContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('p-5 text-baseFg', className)} {...props} />,
);

ModalContent.displayName = 'ModalContent';

const ModalFooter = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center p-[20px] pt-0', className)} {...props} />
  ),
);

ModalFooter.displayName = 'ModalFooter';

const Modal = {
  Container: ModalContainer,
  Header: ModalHeader,
  Close: CloseButton,
  Footer: ModalFooter,
  Title: ModalTitle,
  Description: ModalDescription,
  Content: ModalContent,
};

export { Modal };
